<template>
  <div class="idm-promotion-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="../assets/idman_logo.png" class="logo-icon" alt="IDM Logo">
          <span class="logo-text">INTERNET DOWNLOAD MANAGER</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/idm2" :style="{ color: '#666' }">首页</el-menu-item>
          <el-menu-item index="/order-query" :style="{ color: '#666' }">订单查询</el-menu-item>
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-left">
          <!-- IDM Logo and Title in one line -->
          <div class="logo-title-container">
            <div class="idm-logo-container">
              <img src="../assets/idm.png" alt="IDM Logo" class="idm-logo">
            </div>
            <h1 class="hero-title">Internet Download Manager<br><span class="highlight">让下载速度提升5倍</span></h1>
          </div>
          <!-- <span class="highlight">让下载更高效</span> -->
          <!-- <div class="tagline">提升下载速度高达500%</div> -->
          <p class="hero-description">
            <strong>IDM是Windows平台上最强大的下载工具</strong>，支持多线程下载、断点续传和智能文件分类，
            让您的下载体验更高效、更可靠。<strong>提升下载速度高达5倍</strong>，全球超过4000万用户的共同选择！
          </p>
          <div class="hero-actions">
            <el-button type="primary" size="large" class="download-btn" @click="downloadIDM">
            <!-- <el-button type="success" size="large" class="download-btn" @click="downloadIDM"> -->
              <el-icon><Download /></el-icon>
              立即下载 IDM
            </el-button>
            <!-- <el-button type="success" size="large" class="buy-btn" @click="buyIDM">
              <el-icon><ShoppingCart /></el-icon>
              立即购买 ¥198
            </el-button> -->
          </div>
          <div class="system-info">
            <img src="../assets/Windows.png" alt="Windows">
            支持 Windows 11/10/8.1/8/7 全系列操作系统 | 大小: 12.5 MB
          </div>
        </div>
        <div class="hero-right">
          <div class="software-screenshot">
            <div class="carousel-container" @mouseenter="stopCarousel" @mouseleave="startCarousel">
              <div class="carousel-wrapper">
                <div class="carousel-slide" :class="{ active: currentSlide === 0 }">
                  <img src="../assets/idm-preview1.png" 
                       alt="IDM界面展示1" class="idm-interface"
                       @error="handleImageError"
                       @load="checkImageLoaded">
                </div>
                <div class="carousel-slide" :class="{ active: currentSlide === 1 }">
                  <img src="../assets/idm-preview2.png" 
                       alt="IDM界面展示2" class="idm-interface"
                       @error="handleImageError"
                       @load="checkImageLoaded">
                </div>
                <div class="carousel-slide" :class="{ active: currentSlide === 2 }">
                  <img src="../assets/idm-preview.png" 
                       alt="IDM界面展示3" class="idm-interface"
                       @error="handleImageError"
                       @load="checkImageLoaded">
                </div>
              </div>
              <div class="carousel-indicators">
                <div 
                  v-for="(slide, index) in 3" 
                  :key="index"
                  class="indicator"
                  :class="{ active: currentSlide === index }"
                  @click="currentSlide = index"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Features Section -->
    <div class="section features-section">
      <div class="section-header">
        <h2 class="section-title">IDM核心功能</h2>
        <p class="section-description">IDM提供了一系列高级功能，使您的下载体验更加高效便捷</p>
      </div>
      
      <div class="features-grid">
        <div class="feature-card" v-for="(feature, index) in features" :key="index">
          <div class="feature-icon">
            <i :class="feature.icon"></i>
          </div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </div>
      </div>
    </div>

    <!-- Advantages Section -->
    <div class="section advantages-section">
      <div class="section-header">
        <h2 class="section-title">为什么选择IDM</h2>
        <p class="section-description">全球超过4000万用户的共同选择</p>
      </div>
      
      <div class="advantages-grid">
        <div class="advantage-card" v-for="(advantage, index) in advantages" :key="index">
          <div class="advantage-icon">
            <el-icon :size="32"><component :is="advantage.icon" /></el-icon>
          </div>
          <h3 class="advantage-title">{{ advantage.title }}</h3>
          <p class="advantage-description">{{ advantage.description }}</p>
        </div>
      </div>
    </div>

    <!-- Testimonials Section -->
    <div class="section testimonials-section">
      <div class="section-header">
        <h2 class="section-title">用户评价</h2>
        <p class="section-description">听听全球用户对IDM的评价</p>
      </div>
      
      <div class="testimonials-grid">
        <div class="testimonial-card" v-for="(testimonial, index) in testimonials" :key="index">
          <div class="testimonial-content">
            <p>{{ testimonial.content }}</p>
          </div>
          <div class="testimonial-author">
            <div class="author-avatar">{{ testimonial.avatar }}</div>
            <div class="author-info">
              <h4>{{ testimonial.name }}</h4>
              <p>{{ testimonial.role }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="section faq-section">
      <div class="section-header">
        <h2 class="section-title">常见问题</h2>
        <p class="section-description">您可能关心的问题</p>
      </div>
      
      <div class="faq-container">
        <el-collapse v-model="activeFaq" accordion>
          <el-collapse-item 
            v-for="(faq, index) in faqs" 
            :key="index" 
            :name="index"
            :title="faq.question"
          >
            <p>{{ faq.answer }}</p>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- 客服联系方式 -->
    <div class="customer-service">
      <div class="service-toggle" @click="toggleServicePanel">
        <el-icon><Service /></el-icon>
        <span>{{ isServicePanelOpen ? '收起客服' : '联系客服' }}</span>
      </div>
      <div class="service-content" :class="{ 'expanded': isServicePanelOpen }">
        <div class="service-header">
          <span>客服咨询</span>
        </div>
        <div class="service-body">
          <div class="qrcode-container">
            <img src="../assets/wechat.png" alt="企业微信二维码" class="qrcode-img">
          </div>
          <div class="service-info">
            <p>企业微信</p>
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" class="service-link">
              点击添加客服
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="cta-section">
      <h2>立即体验极速下载</h2>
      <p>提升您的下载体验，享受更快的速度和更稳定的服务</p>
      <el-button type="primary" size="large" class="cta-button" @click="downloadIDM">
        <el-icon><Download /></el-icon>
        立即下载 IDM
      </el-button>
    </div>

    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <p class="copyright">Copyright©2025 51softdown.cn All rights reserved.</p>
        <p class="contact-info">本网站的图文和软件来自于网络，如有内容侵犯您的合法权益，请及时与我们联系，我们会立即删除，联系邮箱: softdown51@outlook.com</p>
        <div class="footer-links">
          <span>奇安科技有限公司贵州分公司</span>
          <!-- <span>豫公网安备 XXXXXXXXXX号</span> -->
          <span>豫ICP备2025146548号</span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Download,
  Service,
  // ShoppingCart
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/idm') {
    return '/idm'
  } else if (route.path === '/idm2') {
    return '/idm2'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/idm') {
    router.push('/idm')
  } else if (key === '/idm2') {
    router.push('/idm2')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}


// 下载IDM
const downloadIDM = () => {
  // 发送Umami自定义事件 - IDM下载
  if (window.umami) {
    window.umami.track('download-idm-v6.42', {
      type: 'software',
      name: 'IDM',
      version: 'latest',
      url: 'https://file.51softdown.cn/download/idm/IDM_v6.42.0.exe'
    });
  }
  
  // 实际的下载逻辑
  window.open('https://file.51softdown.cn/download/idm/IDM_v6.42.0.exe', '_blank');
}

// 购买IDM
// const buyIDM = () => {
//   // 发送Umami自定义事件 - IDM购买
//   if (window.umami) {
//     window.umami.track('buy-idm', {
//       type: 'software',
//       name: 'IDM',
//       version: 'latest',
//       price: '198'
//     });
//   }
//   // 这里可以添加实际的购买逻辑
//   alert('跳转到购买页面...');
//   // window.open('购买链接', '_blank');
// }

// 功能特性数据
const features = ref([
  {
    icon: 'fas fa-rocket',
    title: '极速下载',
    description: '通过智能动态文件分段技术，将下载速度提升高达5倍'
  },
  {
    icon: 'fas fa-redo',
    title: '断点续传',
    description: '支持恢复中断的下载，无需重新开始下载整个文件'
  },
  {
    icon: 'fas fa-globe',
    title: '浏览器集成',
    description: '无缝集成到所有主流浏览器，一键捕获下载链接'
  },
  {
    icon: 'fas fa-tasks',
    title: '下载队列',
    description: '智能安排和管理多个下载任务，优化网络资源使用'
  },
  {
    icon: 'fas fa-shield-alt',
    title: '安全可靠',
    description: '内置病毒检查功能，确保下载文件的安全性'
  },
  {
    icon: 'fas fa-video',
    title: '视频捕获',
    description: '自动检测并下载网页中的视频内容，支持多种格式'
  }
])

// 优势数据
const advantages = ref([
  {
    icon: 'Rocket',
    title: '速度提升5倍',
    description: '通过多线程技术和动态文件分割，大幅提升下载速度'
  },
  {
    icon: 'Refresh',
    title: '断点续传',
    description: '网络中断也不怕，自动恢复下载进度'
  },
  {
    icon: 'Globe',
    title: '全面浏览器支持',
    description: '兼容所有主流浏览器，无缝集成体验'
  },
  {
    icon: 'List',
    title: '智能下载管理',
    description: '自动分类整理下载文件，方便查找和管理'
  }
])

// 用户评价数据
const testimonials = ref([
  {
    content: "IDM彻底改变了我的下载体验。以前需要几小时下载的文件，现在只需几分钟。浏览器集成功能也非常出色，自动捕获下载链接。",
    avatar: "JL",
    name: "张伟",
    role: "软件工程师"
  },
  {
    content: "作为一名内容创作者，我经常需要下载高清视频素材。IDM的视频捕获功能非常强大，几乎可以下载任何网站的视频内容，而且速度惊人。",
    avatar: "ML",
    name: "李敏",
    role: "视频编辑师"
  },
  {
    content: "我已经使用IDM超过5年了，它是我电脑上必不可少的工具之一。断点续传功能在下载大文件时特别有用，再也不用担心网络中断导致下载失败。",
    avatar: "PW",
    name: "王平",
    role: "IT经理"
  }
])

// FAQ数据
const faqs = ref([
  {
    question: "IDM是否支持我的浏览器？",
    answer: "是的，IDM支持所有主流浏览器，包括Google Chrome、Mozilla Firefox、Microsoft Edge、Opera、Safari等。安装IDM后，它会自动集成到您的浏览器中。"
  },
  {
    question: "IDM如何实现加速下载？",
    answer: "IDM通过智能动态文件分段技术加速下载。它将文件分成多个部分，然后同时下载这些部分，最后将它们组合成一个文件。这种方法充分利用了您的可用带宽，使下载速度提高高达5倍。"
  },
  {
    question: "IDM有免费版本吗？",
    answer: "IDM提供30天全功能免费试用。试用期结束后，您需要购买许可证才能继续使用。一次性购买可获得终身免费更新和技术支持。"
  },
  {
    question: "IDM是否安全？",
    answer: "是的，IDM是完全安全的软件。它不包含任何间.spyware、广告软件或恶意代码。IDM还内置了病毒检查功能，可以在下载完成后自动扫描文件。"
  },
  {
    question: "如何更新IDM？",
    answer: "IDM会自动检查更新。当有新版本可用时，它会提示您下载并安装。您也可以通过菜单中的'检查更新'选项手动检查更新。"
  }
])

// 激活的FAQ项
const activeFaq = ref(0)

// 轮播图相关
const currentSlide = ref(0)

// 自动轮播
let carouselInterval = null

// 开始轮播
const startCarousel = () => {
  carouselInterval = setInterval(() => {
    currentSlide.value = (currentSlide.value + 1) % 3; // 循环切换0、1和2
  }, 3000)
}

// 停止轮播
const stopCarousel = () => {
  if (carouselInterval) {
    clearInterval(carouselInterval)
    carouselInterval = null
  }
}

// 图片加载错误处理
const handleImageError = (event) => {
  console.error('图片加载失败:', event.target.src)
  // 设置默认背景色或占位符
  event.target.style.backgroundColor = '#f8f9fa'
  event.target.alt = '图片加载失败'
}

// 添加一个方法来检查图片是否正确加载
const checkImageLoaded = (event) => {
  console.log('图片加载成功:', event.target.src)
}

// 组件挂载时开始轮播
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  startCarousel()
  
  // 设置页面标题和 favicon
  document.title = 'IDM最新版本下载'
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/idm.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/idm.ico'
    document.head.appendChild(favicon)
  }
})

// 客服面板相关
const isServicePanelOpen = ref(false)

const toggleServicePanel = () => {
  isServicePanelOpen.value = !isServicePanelOpen.value
}

onUnmounted(() => {
  stopCarousel()
})
</script>

<style scoped>
.idm-promotion-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f8ff 0%, #e6f3ff 50%, #ffffff 100%);
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #3F414B;
  /* background: linear-gradient(135deg, #1890ff, #40a9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; */
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
}

/* Hero Section */
.hero-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at top right, rgba(255, 193, 7, 0.15) 0%, transparent 70%);
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.hero-left {
  flex: 1;
  max-width: 600px; /* 增加左侧内容宽度，让布局更饱满 */
  padding: 20px;
}

.hero-right {
  flex: 1;
  display: flex;
  justify-content: center;
  min-width: 600px; /* 确保右侧有足够空间显示轮播图 */
}

/* Logo and Title Container */
.logo-title-container {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

/* IDM Logo Styles */
.idm-logo-container {
  flex-shrink: 0;
}

.idm-logo {
  height: 80px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
}

.idm-logo:hover {
  transform: scale(1.05);
}

/* Hero Title Styles */
.hero-title {
  font-size: 1.60rem;
  line-height: 1.2;
  margin-bottom: 20px;
  font-weight: 700;
  flex: 1;
}

.hero-title .highlight {
  color: #ffc107;
}

.tagline {
  color: #ffc107;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-description {
  font-size: 1.1rem;
  margin-bottom: 30px;
  opacity: 0.9;
  max-width: 600px;
}

.hero-actions {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.download-btn {
  background-color: #1FB393;
  border-radius: 25px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  padding: 25px 36px;
  color: #fff;
  letter-spacing: 1px;
  border: 1px solid #1FB393;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition-duration: 1s;
  transition-property: box-shadow, border-color, background-color, color;
  box-shadow: 0 6px 16px rgba(31, 179, 147, 0.3);
  min-width: 180px;
}

.download-btn:hover {
  background-color: #1a9a80;
  border-color: #1a9a80;
  box-shadow: 0 8px 24px rgba(31, 179, 147, 0.4);
  transform: translateY(-2px);
}

.buy-btn {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  border: none;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.buy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.6);
}

.system-info {
  opacity: 0.7;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.hero-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.software-screenshot {
  width: 100%;
  max-width: 821px;
  height: 430px;
  overflow: hidden;
  animation: float 6s ease-in-out infinite;
}

/* 轮播图样式 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 450px; /* 调整高度以更好地展示图片 */
  overflow: hidden;
  background: transparent;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  /* 添加内边距使图片不紧贴边缘 */
  padding: 20px;
  box-sizing: border-box;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  background-color: transparent;
  display: block;
  border: none;
  outline: none;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: #1FB393;
  transform: scale(1.2);
}

.indicator:hover {
  background: rgba(31, 179, 147, 0.8);
}

.idm-interface {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  display: block;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

/* Section Styles */
.section {
  padding: 100px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 15px;
  background: linear-gradient(90deg, #1976d2, #ffc107);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-description {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto;
  opacity: 0.8;
  color: #666;
}

/* Features Section */
.features-section {
  background: white;
}

.features-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  padding: 0 20px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(25, 118, 210, 0.1);
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(255, 193, 7, 0.05) 100%);
}

.feature-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(25, 118, 210, 0.3);
  box-shadow: 0 10px 30px rgba(25, 118, 210, 0.15);
}

.feature-icon {
  font-size: 48px;
  margin-bottom: 25px;
  color: #1976d2;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.feature-description {
  font-size: 1rem;
  opacity: 0.8;
  color: #666;
}

/* Advantages Section */
.advantages-section {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(255, 193, 7, 0.05) 100%);
}

.advantages-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.advantage-card {
  background: white;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.1);
  transition: all 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.2);
}

.advantage-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1976d2, #ffc107);
  border-radius: 50%;
  color: white;
}

.advantage-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.advantage-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
}

/* Testimonials Section */
.testimonials-section {
  background: white;
}

.testimonials-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  padding: 0 20px;
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 30px;
  position: relative;
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.testimonial-card::before {
  content: '"';
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 80px;
  color: #1890ff;
  opacity: 0.2;
  font-family: serif;
  line-height: 1;
}

.testimonial-content {
  margin-top: 20px;
  font-style: italic;
  opacity: 0.9;
  color: #333;
  line-height: 1.8;
}

.testimonial-content p {
  margin: 0;
}

.testimonial-author {
  display: flex;
  align-items: center;
  margin-top: 25px;
}

.author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1890ff, #00cc99);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  margin-right: 15px;
}

.author-info h4 {
  font-size: 1.1rem;
  margin-bottom: 5px;
  color: #333;
}

.author-info p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

/* FAQ Section */
.faq-section {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.05) 0%, rgba(0, 204, 153, 0.05) 100%);
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

:deep(.el-collapse) {
  border: none;
}

:deep(.el-collapse-item__header) {
  background: white;
  border: 1px solid #e6f3ff;
  border-radius: 8px;
  padding: 20px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 15px;
}

:deep(.el-collapse-item__wrap) {
  background: white;
  border: 1px solid #e6f3ff;
  border-top: none;
  border-radius: 0 0 8px 8px;
  margin-bottom: 15px;
}

:deep(.el-collapse-item__content) {
  padding: 20px;
  color: #666;
  line-height: 1.8;
}

/* CTA Section */
.cta-section {
  text-align: center;
  padding: 100px 20px;
  background: linear-gradient(135deg, #1890ff, #00cc99);
  color: white;
}

.cta-section h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-section p {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 40px;
  opacity: 0.9;
}

.cta-button {
  background-color: #1a9a80;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  padding: 20px 36px;
  color: #fff;
  letter-spacing: 1px;
  border: 1px solid #1a9a80;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition-duration: 1s;
  transition-property: box-shadow, border-color, background-color, color;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(31, 179, 147, 0.3);
  min-width: 200px;
}

.cta-button:hover {
  background-color: #117561;
  border-color: #117561;
  box-shadow: 0 10px 28px rgba(31, 179, 147, 0.4);
  transform: translateY(-2px);
}

/* Footer */
.footer {
  background: #f8fafe;
  color: #666;
  text-align: center;
  padding: 30px 0 50px 0; /* 顶部30px，底部50px（30px + 20px） */
  height: auto !important;
  border-top: 1px solid #e6f3ff;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.copyright {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #333;
}

.contact-info {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #333;
  background: #f8fafe;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 12px;
  color: #999;
  flex-wrap: wrap;
}

/* 客服联系方式 */
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

.service-toggle {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  text-align: center;
  padding: 12px 0;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  width: 180px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-size: 14px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.service-toggle:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  box-shadow: 0 6px 24px rgba(24, 144, 255, 0.3);
  transform: translateY(-2px);
}

.service-content {
  background: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 180px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}

.service-content.expanded {
  max-height: 300px;
}

.service-header {
  background: #1890ff;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.service-body {
  padding: 15px;
}

.qrcode-container {
  text-align: center;
  margin-bottom: 15px;
}

.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.service-info {
  text-align: center;
}

.service-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.service-link {
  display: inline-block;
  background: #1890ff;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  transition: background 0.3s;
}

.service-link:hover {
  background: #40a9ff;
}

/* Responsive */
@media (max-width: 768px) {
  .customer-service {
    display: none;
  }
  
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
  
  .features-grid,
  .advantages-grid,
  .testimonials-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
}
</style>